// Featured product showcase: gallery arrows + variant selection.
//
// Variant choice drives a real <select name="id"> so the form still submits a
// valid variant with JavaScript disabled; the swatch buttons are an enhancement
// layered on top of it.

function initShowcase(root) {
  if (root.dataset.showcaseInit) return;
  root.dataset.showcaseInit = '1';

  const track = root.querySelector('[data-showcase-track]');
  const prev = root.querySelector('[data-showcase-prev]');
  const next = root.querySelector('[data-showcase-next]');
  const select = root.querySelector('[data-showcase-select]');
  const swatches = Array.prototype.slice.call(root.querySelectorAll('[data-showcase-variant]'));
  const priceEl = root.querySelector('[data-showcase-price]');
  const submit = root.querySelector('[data-showcase-submit]');
  const qty = root.querySelector('[data-showcase-qty]');

  // ---- gallery -----------------------------------------------------------
  if (track) {
    const step = function () {
      const slide = track.querySelector('.fps__slide');
      return slide ? slide.getBoundingClientRect().width : track.clientWidth;
    };

    const sync = function () {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    };

    prev?.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next?.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  // ---- variants ----------------------------------------------------------
  function selectVariant(id) {
    if (!select) return;
    select.value = id;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncFromSelect() {
    if (!select) return;
    const id = select.value;
    const option = select.options[select.selectedIndex];
    if (!option) return;

    swatches.forEach(function (el) {
      const on = el.dataset.showcaseVariant === id;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (priceEl && option.dataset.price) priceEl.innerHTML = option.dataset.price;

    const available = option.dataset.available === 'true';
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available
        ? submit.dataset.labelAvailable
        : submit.dataset.labelSoldOut;
    }
    if (qty) qty.disabled = !available;

    // Scroll the gallery to this variant's image when it has one.
    const mediaIndex = option.dataset.mediaIndex;
    if (track && mediaIndex) {
      const slide = track.querySelectorAll('.fps__slide')[Number(mediaIndex)];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
  }

  swatches.forEach(function (el) {
    el.addEventListener('click', function () {
      selectVariant(el.dataset.showcaseVariant);
    });
  });

  select?.addEventListener('change', syncFromSelect);
  syncFromSelect();
}

function bootShowcase(scope) {
  (scope || document).querySelectorAll('[data-featured-showcase]').forEach(initShowcase);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootShowcase();
  });
} else {
  bootShowcase();
}

document.addEventListener('shopify:section:load', function (e) {
  bootShowcase(e.target);
});
